<template>
    <div>
      <div class="alert alert-danger" role="alert" v-if="error">
        {{ error.message }}
      </div>

      <div class="">
        <form class="needs-validation" autocomplete="off" @submit.prevent="login" method="POST" novalidate>
          <div class="form-group">
            <label for="username">
              E-mail
            </label>

            <input type="email"
              :class="{ 'form-control': true, 'is-invalid': usernameError }"
              id="username"
              name="username"
              v-model="credentials.username"
              placeholder="Insira seu email"
              required>

            <span v-if="usernameError" class="invalid-feedback">
              <strong>
                {{ usernameError }}
              </strong>
            </span>
          </div>

          <div class="form-group">
            <label for="password">
              Senha
            </label>

            <input type="password"
              id="password"
              :class="{ 'form-control': true, 'is-invalid': passwordError }"
              placeholder="Digite sua senha"
              v-model="credentials.password"
              required>

            <span v-if="passwordError" class="invalid-feedback">
              <strong>
                {{ passwordError }}
              </strong>
            </span>
          </div>

          <button type="submit" :disabled="processing" 
            :class="{
              'btn btn-primary btn-block btn-flat': true,
              'btn-loading': processing
            }">
            
            Entrar
          </button>

          <div class="form-group text-center auth-link">
            <router-link :to="{ name: 'auth.forgot-password' }">
              <small>
                Esqueci minha senha
              </small>
            </router-link>
          </div>

        </form>
      </div>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    data () {
      return {
        processing: false,

        credentials: {
          username: '',
          password: ''
        }
      }
    },

    computed: {
      ...mapGetters({
        error: 'errors/getFirstGlobal',
        fieldError: 'errors/getFirstGlobalError'
      }),

      usernameError () { return this.fieldError('username') },
      passwordError () { return this.fieldError('password') }
    },

    methods: {
      ...mapActions({
        storeToken: 'auth/storeToken',
        pushError: 'errors/pushGlobalError',
        clearError: 'errors/clearGlobalErrors'
      }),

      login () {
        const self = this
        self.processing = true
        // if (self.processing) {
        //   let $btnSubmit = document.querySelector('button[type="submit"]')
        //   $btnSubmit.classList.add('sending')
        //   $btnSubmit.setAttribute('disabled', true)
        // }
        self.clearError()
        self.$auth.login({
          params: self.credentials,
          success () {
            self.processing = false
            self.storeToken([self.$auth])
          },
          error (e) {
            self.processing = false
            if (e.response) {
              self.pushError([e.response.data])
            }
          },
          redirect: { name: 'app.dashboard' },
          rememberMe: true,
          fetchUser: true
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  form
    font-weight: normal;
    margin-top: 50px;

    label
      color: #666666;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;

    input
      height: 55px;
      border: 1px solid #ccc;

    .btn
        margin: 30px 0px 20px;
        height: 55px;
        font-weight: bold;
        font-size: 14px;
        text-transform: uppercase;


  .auth-link

    small
      font-weight: 600;
      font-size: 12px;
      color: #666666;
      transition: 500ms linear;

      &:hover

        color: #000;


</style>



// WEBPACK FOOTER //
// src/components/pages/auth/Login.vue